import { component } from 'picoapp'
import { getSizedImageUrl, imageSize } from '@/lib/images.js'
import { formatMoney } from '@/lib/currency.js'
import app from '@/app.js'

const X = `<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentcolor" stroke-width="3" style="display:inline-block;vertical-align:middle;overflow:visible;"><path d="M1.0606601717798212 1.0606601717798212 L14.939339828220179 14.939339828220179"></path><path d="M14.939339828220179 1.0606601717798212 L1.0606601717798212 14.939339828220179"></path></svg>`

function createItem ({
  variant_id: id,
  product_title: title,
  line_price: price,
  variant_title: color,
  variant_options: options,
  image,
  url,
  quantity,
  properties
}) {

  const img = image;
  const qtyLimit = 10;
  let finalSale = false;
  let finalSaleHtml = [];
  let qtyHtml = [];
  let optionHtml = [];

  let genderCap = false;
  let size = false;
  let gender = false;

  if (properties) {
    finalSale = properties.['_Final Sale'];
    gender = properties._gender;

    if (properties._gender) {
      genderCap = gender.charAt(0).toUpperCase() + gender.slice(1);
    }
  }

  if (title.indexOf('/') > 0) {
    title = title.split('/')[0];
  }

  //Collect variant option span elems
  for(let i=0; i<=options.length; i++) {
    if (typeof options[i] !== "undefined") {
      let option = options[i];
      let html = `<span>${option}</span>`;

      //Assign gender size from line item property
      if (genderCap != '' && option.includes(genderCap)) {
        const sizes = option.split('|');
        for(let i=0; i<=sizes.length; i++) {
          if (typeof sizes[i] !== "undefined") {
            if (sizes[i].includes(genderCap)) {
              size = sizes[i].replace(genderCap, '').trim();
            }
          }
        }
        html = `<span>${size} (${genderCap})</span>`;
      }
      else if (option.includes('Default Title')) {
        html = ' ';
      }

      optionHtml.push(html);
    }
  }

  if (typeof finalSale !== 'undefined' && finalSale != false) {
    finalSaleHtml.push(`<span class="price__highlight">Final Sale</span>`);
  }

  //Collect quantity select option elems
  for(let i=0; i<=qtyLimit; i++) {
    const selected = i == quantity ? 'selected' : '';
    const html = `<option value="${i}" ${selected}>${i}</option>`;
    qtyHtml.push(html);
  }

  optionHtml = optionHtml.join(' ');
  qtyHtml = qtyHtml.join(' ');

  return `
<div class='cart-drawer__item' data-component='cartDrawerItem' data-id=${id}>
  <div class='f'>
    <a class="item__image" href='${url}'>
      <img src='${img}' />
    </a>
    <div class='item__content'>
      <div>
        <div class="item__header">
          <a href="${url}" class="item__title">${title}</a>
          <div class="item__price">
            <span>${formatMoney(price)}</span>
            ${finalSaleHtml}
          </div>
        </div>
        <div class="item__options">
          ${optionHtml}
          <span class="item__quantity">
            Quantity
            <select name="quantity" class="js-change-quantity">
              ${qtyHtml}
            </select>
          </span>
        </div>
        <button class="js-remove-item item__remove button--reset" type="button">Remove</button>
      </div>
    </div>
  </div>
</div>
`
}

function renderItems (items) {
  return items.length > 0 ? (
    items.reduce((markup, item) => {
      markup += createItem(item)
      return markup
    }, '')
  ) : (
    `<div class='pv1'><p class='pv1 mv05 sans small cm i ac'>Your cart is empty</p></div>`
  )
}

export default component((node, ctx) => {
  const overlay = node.querySelector('.js-cart-overlay');
  const closeButton = node.querySelector('.js-close');
  const $subtotal = $('.js-subtotal');
	const $freeDrawer = $('.js-free-drawer');
  const itemsRoot = node.querySelector('.js-items');
  const $cartCount = $('.js-cart-count');
  const loading = itemsRoot.innerHTML;
  const $upsell = $('.js-upsell');
	const freeThreshold = $freeDrawer.attr('data-free-threshold');
  const render = (cart) => {
    itemsRoot.innerHTML = renderItems(cart.items);

    $subtotal.each(function() {
      $(this).html(formatMoney(cart.total_price));
    });

		if ($freeDrawer.length) {
			if (cart.total_price >= freeThreshold) {
				$freeDrawer.html('FREE');
			} else {
				$freeDrawer.html(`You are <b>${formatMoney(freeThreshold - cart.total_price)}</b> away from a free shipping`);
			}
		}

    const plural = cart.item_count > 1 || cart.item_count == 0 ? 's' : '';
    const countString = cart.item_count + ' item' + plural;

    $cartCount.each(function() {
      $(this).html(countString);
    });

    if ($upsell.length) {
      let showUpsell = cart.item_count > 0 ? true : false;


      if (showUpsell) {
        $upsell.addClass('active');
      }
      else {
        $upsell.removeClass('active');
      }
    }
  }

  const open = (cart) => {
    node.classList.add('is-active')
    itemsRoot.innerHTML = loading
    setTimeout(() => {
      node.classList.add('is-visible')
      setTimeout(render(cart), 10)
      app.mount()
    }, 50)
  }

  const close = () => {
    if (!node.classList.contains('is-visible')) {
      return;
    }

    node.classList.remove('is-visible');
    $panelOverlay.removeClass('active');
    $('body').removeClass('no-scroll');
    $('html').removeClass('no-scroll');

    setTimeout(() => {
      node.classList.remove('is-active')
      app.hydrate({cartOpen: false})
    }, 400)
  }

  render(ctx.getState().cart)

  const $panelOverlay = $('.js-overlay');

  if ($panelOverlay.length) {
    $panelOverlay[0].addEventListener('click', close);
  }

  if (closeButton) {
    closeButton.addEventListener('click', close);
  }

  ctx.on('cart:toggle', ({ cart, cartOpen }) => {
    cartOpen && open(cart);
    $panelOverlay.addClass('active');
    $('body').addClass('no-scroll');
    $('html').addClass('no-scroll');
  })
  ctx.on('cart:updated', () => {
    render(ctx.getState().cart)
    app.mount()
  });

  if ($('.js-cart-page').length) {
    app.emit('cart:toggle', state => {
      return {
        cartOpen: !state.cartOpen
      }
    })
  }

})

